import React from 'react'
import "./pageBlog.css";

import HeaderBlog5 from "../pageBlog/HeaderBlog5";
 import BodyBlog5 from "../pageBlog/BodyBlog5";
import Footer2 from "../footer2/Footer2";

function PageBlog5() {
  return (
    <section>
      
       <HeaderBlog5/>
       <BodyBlog5/>
       <Footer2/>
    </section>
  )
}

export default PageBlog5